import * as React from "react";

function SvgBottom(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}><path d="M0 0v16h16V0H0zm13 13H3V3h10v10z" opacity={0.06} fill="#555d63" /><path d="M3.8 13h8.4l2.2 2.3c.2.2.1.7-.2.7H1.8c-.3 0-.4-.3-.2-.7L3.8 13z" fill="#555d63" /></svg>;
}

export default SvgBottom;